import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import DashboardCommonTable from "../../components/DashboardCommonTable";
import { Col, notification, Row, Tooltip } from "antd";
import EditTrade from "../../components/EditTrade/EditTrade";
import VerificationModal from "../../components/VerificationModal/VerificationModal";
import { labelObj, marketTag, options } from "../../Helper/constant";
import {
  ClientNameCol,
  DeleteIcon,
  EditIcon,
  SmallTag,
  TradeTableActionCol,
  onlyTime,
} from "./style";
import {
  findMarket,
  formatNumber,
} from "../../components/FormateToINR/formatToINR";
import { limitNumberLength } from "../../components/SocketLiveData";
import { DesktopOutlined, MobileOutlined } from "@ant-design/icons";
import { UplineTag } from "../Users/Accounts/style";
import { MarketTableTag } from "../MarketWatch/style";
const LetestTradeTable = React.memo(({ customerScreen, filterValue }) => {
  const queryClient = useQueryClient();

  //state
  const [showModal, setShowModal] = useState({
    name: null,
    flag: false,
    record: null,
  });
  const [filter, setFilter] = useState(null);

  //redux
  const LoginDetails = useSelector((state) => state?.authSlice?.userDetail);
  const addition = useSelector((state) => state?.authSlice?.additionalSharing);
  const loginUserId = LoginDetails?.userId;
  const loginAccountType = LoginDetails?.accountType;
  const isOwner = loginAccountType === "owner";
  const actionAllow =
    loginAccountType !== "customer" && loginAccountType !== "broker";
  const isStale = queryClient
    .getQueryCache()
    .find(["allTrade", null])
    ?.isStale();

  // // life cycle
  useEffect(() => {
    if (isStale) {
      queryClient.invalidateQueries({ queryKey: ["allTrade", null] });
    }
  }, []);

  // api call
  const fetchInitialData = async ({ pageParam = 1 }) => {
    let obj = { userId: loginUserId, tradeStatus: "executed", title: filter };
    if (filterValue) obj = { ...obj, ...filterValue };
    let url = `${EndPoints.getTrade}?page=${pageParam}&limit=10`;
    if (!customerScreen) url += "&isLatest=true";
    const response = await APICall("post", url, obj);
    return response?.data?.data;
  };

  const tradeQuery = useInfiniteQuery({
    queryKey: customerScreen
      ? ["allTrade", filter, filterValue]
      : ["allTrade", filter],
    queryFn: fetchInitialData,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
    refetchOnMount: customerScreen ? true : false,
  });

  if (tradeQuery?.error) {
    notification.error({ message: tradeQuery?.error?.message });
  }

  const newPageData =
    tradeQuery?.data?.pages?.flatMap((page) => page && page?.trades) || [];

  // Get totalCount from the first page of API response
  const totalCount = tradeQuery?.data?.pages?.[0]?.totalCount || 0;

  // function`
  const handleCancel = () => {
    // setShowModal(false);
    setShowModal({ name: null, flag: false, record: null });
  };

  const handleEdit = (record, key) => {
    setShowModal({ name: "edit", flag: true, record: { ...record, key } });
  };

  const filterOption = options.trading.orderType?.map((el) => ({
    ...el,
    text: el?.label,
  }));

  const handleChange = (pagination, filters, sorter) => {
    if (filters?.ordertype?.[0]) {
      setFilter(filters?.ordertype?.[0]);
    } else {
      setFilter(null);
    }
  };

  // column
  const latestTradeColumns = useMemo(
    () => [
      {
        title: "",
        dataIndex: "index",
        key: "index",
        align: "left",
        render: (text, record, index) => {
          return (
            <div>
              {record?.deviceType === "mob" ? <MobileOutlined /> : record?.deviceType === "web" ? <DesktopOutlined /> : "-"}
            </div>
          );
        },
      },
      tradeQuery?.isLoading
        ? {
          title: "TIME",
          dataIndex: "tradeTime",
          key: "tradeTime",
          align: "left",
        }
        : {
          title: "TIME",
          dataIndex: "tradeTime",
          key: "tradeTime",
          align: "left",
          render: (text, record) => {
            const time = onlyTime(record?.tradeTime);
            let executeTime = "";
            if (record?.title === "limit") {
              const excute = onlyTime(record?.executeTime);
              executeTime = excute;
            }
            return (
              <>
                {executeTime ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>{executeTime}</div>
                    <div> {`(${time})`}</div>
                  </div>
                ) : (
                  <div> {time}</div>
                )}
              </>
            );
          },
        },
      {
        title: "CLIENT",
        dataIndex: "customerName",
        key: "customerName",
        align: "left",
        flex: 1,
        ellipsis: true,
        render: (text, record) => {
          let id = record?.customer[0]?.userId;
          return (
            <>
              {/* <Tooltip
              title={`${id} (${record?.customer[0]?.accountName})`}
              placement="top"
            > */}
              <div>
                <div style={{ fontWeight: "bold" }}>{id}</div>
                <div >{record?.customer[0]?.accountName}</div>
              </div>
              {/* </Tooltip> */}
            </>
          );
        },
      },
      {
        title: "UPLINE",
        dataIndex: "upline",
        key: "upline",
        align: "left",
        flex: 1,
        ellipsis: true,
        render: (text, record) => {
          let id = record?.customer[0]?.parent?.userId;
          return (
            <>
              {/* <Tooltip
              title={`${id} (${record?.customer[0]?.parent?.accountName})`}
              placement="top"
            > */}
              <div>
                <div style={{ fontWeight: "bold" }}>{id}<UplineTag color="magenta" bordered={false}>
                  {labelObj[record?.customer[0]?.parent?.accountType]}
                </UplineTag></div>
                <div >{record?.customer[0]?.parent?.accountName}</div>
              </div>
              {/* </Tooltip> */}
            </>
          );
        },
      },
      {
        title: "MARKET",
        dataIndex: "marketName",
        key: "marketName",
        flex: 1,
        render: (text, record) => {
          return <div>
            {/* <Tooltip title={record?.marketName} placement={"leftTop"}> */}
            <MarketTableTag color="volcano-inverse">
              {marketTag[record?.marketName]}
            </MarketTableTag>
            {/* </Tooltip> */}
          </div>;
        },
      },
      {
        title: "SCRIPT",
        dataIndex: "scriptName",
        key: "scriptName",

        align: "left",
        filters: filterOption,
        filterMultiple: false,
        className: "table-filter",
        render: (text, record) => {
          const date = record?.expiryDate ? record?.expiryDate : "";
          // const date = valanBillDate(record?.expiryDate, false);
          const opt = record?.marketName?.endsWith("OPT");
          const name = opt
            ? `${record?.symbolName} ${record?.series ? record?.series : ""} ${record?.strikePrice ? record?.strikePrice : ""
            }`
            : record?.symbolName;
          return (
            <div>
              <div style={{ textAlign: "left", display: "flex" }}>
                {name}  <SmallTag color="orange" variant="solid" bordered={false}>
                  {record?.title}
                </SmallTag>
                <SmallTag
                  color={record?.tradePattern === "buy" ? "green" : "red"}
                  variant="solid"
                  bordered={false}
                >
                  {record?.tradePattern.toUpperCase()}
                </SmallTag>
              </div>
              <div style={{ textAlign: "left", fontSize: "10px", fontWeight: "bold" }}>
                {date}<text style={{ color: "#728780" }}> ({record?.tradeNumber})</text>
              </div>

            </div>
          );
        },
      },

      {
        title: "QTY (LOT)",
        dataIndex: "lot",
        key: "lot",
        align: "left",
        render: (text, record) => {
          const lot = formatNumber(record?.lot);
          const quantity = formatNumber(record?.quantity);
          const data =
            record?.marketName === "NSE EQU"
              ? quantity
              : `${quantity} (${lot})`;
          return <div>{data}</div>;
        },
      },
      {
        title: "RATE",
        dataIndex: "tradePrice",
        key: "rate",
        align: "center",
        render: (text, record) => {
          const tradePrice = findMarket(record?.marketName)
            ? limitNumberLength(record?.tradePrice)
            : record?.tradePrice?.toFixed(2);
          return <div>{tradePrice}</div>;
        },
      },
      actionAllow && (addition?.editTrade || addition?.tradeDelete)
        ? {
          title: "ACTION",
          dataIndex: "edit",
          key: "edit",
          align: "center",
          render: (text, record, index) => {
            return (
              <TradeTableActionCol>
                {addition?.editTrade &&
                  (record?.deviceType !== "system" || isOwner ? (
                    <EditIcon
                      onClick={() => handleEdit(record, "allTrade")}
                    />
                  ) : (
                    "-"
                  ))}

                {addition?.tradeDelete &&
                  (record?.deviceType !== "system" || isOwner ? (
                    <DeleteIcon
                      onClick={() => {
                        setShowModal({
                          name: "delete",
                          flag: true,
                          record: record,
                        });
                      }}
                    />
                  ) : (
                    "-"
                  ))}
              </TradeTableActionCol>
            );
          },
        }
        : {
          width: "0px",
        },
    ],
    [handleEdit, newPageData]
  );

  return (
    <Col xxl={12} xl={12} lg={24}>
      <DashboardCommonTable
        columns={latestTradeColumns}
        tableTitle="LATEST TRADES"
        viewMore={true}
        allowBtn={false}
        dataSource={newPageData?.[0] ? newPageData : []}
        isLoading={tradeQuery?.isLoading}
        queryKey="allTrade"
        tradeQuery={tradeQuery}
        onChange={handleChange}
        emptyPage={tradeQuery?.data?.pages?.[0]?.trades?.length === 0}
      />

      {showModal?.flag && showModal?.name === "edit" && (
        <EditTrade
          handleCancel={handleCancel}
          record={showModal.record}
          queryKey={["allTrade", filter]}
        />
      )}

      {showModal?.flag && showModal?.name === "delete" && (
        <VerificationModal
          handleCancel={handleCancel}
          record={showModal.record}
          query={["allTrade"]}
          type="delete"
          title={"Delete Trade"}
        />
      )}
    </Col>
  );
});

export default LetestTradeTable;
